import { types } from 'mobx-state-tree';

const Detail = types
  .model('Detail', {
    accountName: types.maybe(types.string),
    destination: types.maybe(types.string),
    itemsListed: types.maybe(types.number),
    time: types.maybe(types.number),
    errors: types.optional(types.array(types.frozen), []),
  });

export default Detail;
